const n = Symbol("dependency manager loaded");
class o {
  constructor(e) {
    this.dependencies = {}, this._loaded = !1, this.host = e;
  }
  get loaded() {
    return this._loaded;
  }
  set loaded(e) {
    e !== this.loaded && (this._loaded = e, this.host.requestUpdate(n, !this.loaded));
  }
  add(e, s) {
    const d = !!s || !!customElements.get(e) || this.dependencies[e];
    d || customElements.whenDefined(e).then(() => {
      this.add(e, !0);
    }), this.dependencies = { ...this.dependencies, [e]: d }, this.loaded = Object.values(this.dependencies).every((t) => t);
  }
}
export {
  o as D
};
//# sourceMappingURL=DependencyManger-BjCNyZOf.js.map
